module.exports = {"510781006":"中坝街道","510781101":"太平镇","510781102":"三合镇","510781103":"含增镇","510781104":"青莲镇","510781105":"彰明镇","510781106":"龙凤镇","510781107":"武都镇","510781108":"大康镇","510781109":"新安镇","510781110":"战旗镇","510781111":"双河镇","510781112":"永胜镇","510781113":"小溪坝镇","510781114":"河口镇","510781115":"重华镇","510781116":"厚坝镇","510781117":"二郎庙镇","510781118":"马角镇","510781119":"雁门镇","510781121":"西屏镇","510781123":"大堰镇","510781125":"方水镇","510781219":"枫顺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510781.json
// module id = 2439
// module chunks = 0